import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=9f7d98de&scoped=true&"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=9f7d98de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7d98de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9f7d98de', component.options)
    } else {
      api.reload('9f7d98de', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=9f7d98de&scoped=true&", function () {
      api.rerender('9f7d98de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/empty.vue"
export default component.exports